/**
 * Removes specified keys from each element in the playlist configuration data.
 *
 * @param {Array.<Object>} playlistConfigData - An array of objects representing playlist config data.
 * @returns {Array.<Object>} An array of objects with specified keys removed from each element in the config
 */

const cleanPlaylistConfigData = (playlistConfigData) => {
	const keysToRemove = ['isDeletable'];

	const cleanedData = playlistConfigData.map((item) => {
		const cleanedItem = { ...item }; // Create a copy of the item
		keysToRemove.forEach((key) => {
			delete cleanedItem[key]; // Remove the specified keys
		});
		return cleanedItem;
	});

	return cleanedData;
};

export { cleanPlaylistConfigData };
